import { useTranslation } from "react-i18next";

import { MonetaryDisplay } from "@/components/ui/monetary-display";
import { cn } from "@/lib/utils";
import { abs, isNegative } from "@/Utils/decimal";

type InvoiceAmountDisplayProps = {
  amount?: string | number | null;
  isRefund?: boolean;
  hideCurrency?: boolean;
  showDirection?: boolean;
  className?: string;
};

export function InvoiceAmountDisplay({
  amount,
  isRefund,
  hideCurrency = false,
  showDirection = false,
  className,
}: InvoiceAmountDisplayProps) {
  const { t } = useTranslation();

  if (amount == null) {
    return <MonetaryDisplay amount={amount} hideCurrency={hideCurrency} />;
  }

  const isCreditAmount = isRefund ?? isNegative(amount);

  return (
    <div
      className={cn(
        "inline-flex items-center gap-1",
        showDirection && "gap-2",
        className,
      )}
    >
      {showDirection && (
        <span className="text-xs font-medium uppercase tracking-wide text-gray-500">
          {t(isCreditAmount ? "credited" : "debited")}
        </span>
      )}
      <MonetaryDisplay amount={abs(amount)} hideCurrency={hideCurrency} />
    </div>
  );
}
